import {
  filesTypes,
  FilesActions,
  DownloadFilePayload
} from './types'

const actions = {
  uploadFile: (
    payload: File,
    callback: (succ: boolean, fileName?: string) => void
  ): FilesActions => ({
    type: filesTypes.UPLOAD_FILE,
    payload,
    callback
  }),
  uploadFiles: (
    payload: File[],
    callback: (succ: boolean, fileNameList?: string[]) => void
  ): FilesActions => ({
    type: filesTypes.UPLOAD_FILES,
    payload,
    callback
  }),
  downloadFile: (
    payload: DownloadFilePayload,
    callback: (succ: boolean) => void
  ): FilesActions => ({
    type: filesTypes.DOWNLOAD_FILE,
    payload,
    callback
  }),
  getPDF: (
    payload: string,
    callback: (succ: boolean) => void
  ): FilesActions => ({
    type: filesTypes.GET_PDF,
    payload,
    callback
  }),
  setPDF: (payload: string): FilesActions => ({
    type: filesTypes.SET_PDF,
    payload
  })
}

export default actions
